import {throttle} from 'throttle-debounce';
import m from '../helpers/metrics';
var h = require('../helpers/helpers');
var overlay = require('./overlayControl');

var sidebar = document.getElementsByClassName('js-contentsNav-sidebar')[0];
var button = document.getElementsByClassName('js-contentsNav-button')[0];
var article = document.getElementsByClassName('js-contentsNav-shift');
var items = document.getElementsByClassName('js-contentsNav-item');
var close_btn = document.getElementsByClassName('js-contentsNav-close')[0];
var inner_scroller = document.getElementsByClassName('c-pageContents_index')[0];

// Interactions
// ------------------------------------------------------
function sideBarInteractions() {

  var sidebar_state = 's-open';
  var open_scroll_pos;

  function hideIfScrolling() {
    var buffer = 500;

    var current_scroll_pos = m('scroll_y');

    if (current_scroll_pos > (open_scroll_pos + buffer) || current_scroll_pos < (open_scroll_pos - buffer) ) {
      hideNav();
    }
  }
  var hideIfScrolling__throttled = throttle(50, hideIfScrolling);

  function showNav() {
    sidebar.classList.add(sidebar_state);

    open_scroll_pos = m('scroll_y');

    overlay.show();

    window.addEventListener('scroll', hideIfScrolling__throttled);
  }

  function hideNav() {
    sidebar.classList.remove(sidebar_state);

    overlay.hide();

    window.removeEventListener('scroll', hideIfScrolling__throttled);
  }

  // Event handling
  // --------------------------------------------------
  function bindEvents() {
    overlay.addClickHandler(hideNav);

    // Update get element dims on resize and they only change when layout is adjusted
    button.addEventListener('click', showNav);

    // Update get element dims on resize and they only change when layout is adjusted
    close_btn.addEventListener('click', hideNav);
  }

  // Bind events
  bindEvents();
}

// Check for element existence prior to execution
if (sidebar) {
  sideBarInteractions();
}